import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabThirteen = ({
  setDesignations,
  designations,
  onClickAll
}) => {
  const handleDesignationChange = (index, data) => {
    const items = [...designations];
    const item = { ...items[index] };
    item.value = !data.value;
    items[index] = item;
    setDesignations(items);
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="designations-form-all"
          control={
            <Checkbox
              id="designations-all"
              checked={designations.every((designation) => designation.value)}
              onClick={(e) => onClickAll(designations, 'common', setDesignations, e)}
            />
          }
          label="All"
        />
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'Create Designation' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={designations[index]?.value}
                    onChange={() => handleDesignationChange(index, data)}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'View Designations' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={designations[index]?.value}
                    onChange={() => handleDesignationChange(index, data)}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'Edit Designation' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={designations[index]?.value}
                    onChange={() => handleDesignationChange(index, data)}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabThirteen;